<script>
import {useRegulationsStore} from "@/stores/regulations.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterRegulationsTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useRegulationsStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.regulationsStore.indexRegulationOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">Regulations</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="regulation in regulationsStore.getRegulationOptions"
        v-bind="$attrs"
        :value="regulation.id"
        :label="regulation.name"
    />
  </div>
</template>

<style scoped>

</style>